




















































































































































import Vue from 'vue';
import { IShoppingCartItem, IShoppingCartSpecialOffer } from '@/common/interfaces/cart.interface';
import { ICustomerOrderItem } from '@/common/interfaces/customers.interface';
import InternetExplorerHelper from '@/helpers/InternetExplorerHelper';
import OldFormatHelper from '../../helpers/OldFormatHelper';

interface IItemsViewComponent {
  InternetExplorerHelper: typeof InternetExplorerHelper;
  formatHelper: typeof OldFormatHelper;
}

export default Vue.extend({
  data(): IItemsViewComponent {
    return {
      InternetExplorerHelper,
      formatHelper: OldFormatHelper,
    };
  },
  computed: {
    allItems(): (ICustomerOrderItem | IShoppingCartItem | IShoppingCartSpecialOffer)[] {
      return [...this.items, ...(this.specialOffers ?? [])];
    },
  },
  props: {
    currency: {
      default: null,
      type: String,
    },
    items: {
      default: () => [],
      type: Array as () => (ICustomerOrderItem | IShoppingCartItem)[],
    },
    specialOffers: {
      default: () => [],
      type: Array as () => IShoppingCartSpecialOffer[] | undefined,
    },
  },
  methods: {
    getItemImage(item: ICustomerOrderItem | IShoppingCartItem | IShoppingCartSpecialOffer): string {
      return item.image || ``;
    },
    getItemTitle(item: ICustomerOrderItem | IShoppingCartItem | IShoppingCartSpecialOffer): string {
      return item.title || ``;
    },
  },
});
